import styled, { css } from "styled-components";
import _ComboEvent from "components/ComboEvent";

const Container = styled.div`
  padding: 2px;
  border-radius: 5px;
  overflow: hidden;
  background-size: 400% 400%;

  &:hover {
    ${(props: { keyframe?: any; disableHover?: boolean }) =>
      !props.disableHover &&
      css`
        position: relative;
        z-index: 1;
      `}
  }
`;

const Trainer = styled.div``;

const Image = styled.div`
  position: relative;

  > img {
    display: block;
  }
`;

const Team = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;

  background: #00000030;
  border-bottom-left-radius: 5px;
`;

const ComboEvent = styled(_ComboEvent)`
  position: absolute;
  top: 0;
  left: 0;
`;

const Details = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  color: black;

  img {
    display: block;
  }
`;

const Levels = styled.div`
  display: flex;
  background: #1a293b;
  padding: 4px 8px;

  img {
    display: block;
  }
`;

const Name = styled.div`
  padding-top: 4px;
  padding-bottom: 2px;
  font-weight: 800;
  background: #0f1925;
  color: white;
  text-align: center;
`;

const Position = styled.div``;

const Type = styled.div`
  width: 30px;
`;

const TrainerDetailsButton = styled.div`
  text-align: center;
  font-weight: 600;
  padding: 4px 8px;
  cursor: pointer;
`;

const TrainerStyles = {
  Container,
  Trainer,
  TrainerDetailsButton,
  Team,
  Type,
  Position,
  Details,
  ComboEvent,
  Levels,
  Name,
  Image,
};

export default TrainerStyles;
